/**
 * Nav model for the product-admin console shell.
 *
 * Two ordered groups (Operations / Configuration) feed AppLayout's sidebar,
 * plus one bottom-anchored item. Paths, labels, icons, order and grouping are
 * 1:1 with the shipped wsr-product-admin console so the URL structure matches
 * and a future real screen drops into the same route.
 *
 * No badge slots: no screen in this phase publishes a live count, so the
 * badge mechanism would be dead code. The first operational screen that needs
 * one reintroduces it.
 */
import type { ReactNode } from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ListAltIcon from '@mui/icons-material/ListAlt';
import NotificationsIcon from '@mui/icons-material/Notifications';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';
import SettingsIcon from '@mui/icons-material/Settings';
import TuneIcon from '@mui/icons-material/Tune';

export interface NavItem {
  to: string;
  key: string;
  fallback: string;
  icon: ReactNode;
}

export interface NavGroup {
  groupKey: string;
  groupFallback: string;
  items: NavItem[];
}

export const NAV_GROUPS: NavGroup[] = [
  {
    groupKey: 'nav.group.operations',
    groupFallback: 'Operations',
    items: [
      { to: '/dashboard', key: 'nav.dashboard', fallback: 'Dashboard', icon: <DashboardIcon /> },
      { to: '/queue', key: 'nav.queue', fallback: 'Queue', icon: <ListAltIcon /> },
      {
        to: '/notifications',
        key: 'nav.notifications',
        fallback: 'Notifications',
        icon: <NotificationsIcon />,
      },
      { to: '/logs', key: 'nav.logs', fallback: 'Logs', icon: <DescriptionIcon /> },
    ],
  },
  {
    groupKey: 'nav.group.configuration',
    groupFallback: 'Configuration',
    items: [
      { to: '/tenants', key: 'nav.tenants', fallback: 'Tenants', icon: <BusinessIcon /> },
      { to: '/engine', key: 'nav.engine', fallback: 'Engine', icon: <SettingsIcon /> },
    ],
  },
];

/** Standalone global configuration link anchored at the drawer bottom. */
export const BOTTOM_NAV_ITEM: NavItem = {
  to: '/global-config',
  key: 'nav.globalConfig',
  fallback: 'Global config',
  icon: <TuneIcon />,
};
